module.exports = __webpack_public_path__ + "img/notify-white.d53ea22d.svg";